import { Folder } from '@core/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TreeNode } from 'primeng/api';
import { USER_FOLDERS_FEATURE_KEY, userFoldersAdapter, UserFoldersState } from './user-folders.reducer';

// Feature selector
export const selectUserFoldersState = createFeatureSelector<UserFoldersState>(USER_FOLDERS_FEATURE_KEY);
const { selectAll, selectEntities } = userFoldersAdapter.getSelectors(selectUserFoldersState);

// Select All User Folders
export const selectAllUserFolders = selectAll;

// Select Folder By Id
export const selectFolderById = (id: string) => createSelector(selectEntities, entities => entities[id]);

// Select All User Folders as Tree Nodes
export const selectAllUserFolderAsTree = createSelector(selectAllUserFolders, folders => {
    const map = new Map<string, TreeNode<Folder>>();

    folders.forEach(folder => {
        map.set(folder.id, {
            key: folder.id,
            label: folder.name,
            data: folder,
            children: []
        });
    });

    const roots: TreeNode<Folder>[] = [];

    folders.forEach(folder => {
        const node = map.get(folder.id)!;
        if (folder.parent) {
            const parentNode = map.get(folder.parent);
            if (parentNode) {
                parentNode.children!.push(node);
                node.parent = parentNode;
            } else {
                // If the parent is not found, goes to root level
                roots.push(node);
            }
        } else {
            // Root level
            roots.push(node);
        }
    });

    return roots;
});

export const selectLastSavedFolderId = createSelector(
    selectUserFoldersState,
    state => state.lastSavedFolderId
);
